var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"dark":"","small":"","color":"orange"}},[_c('v-icon',[_vm._v("mdi-clock")]),_c('from-now',{attrs:{"time":_vm.createdAt}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }